import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { makeStartedRequest, makeSucceededRequest } from '../../requests/factories/makeRequest';
export function createTreatmentContext() {
  return /*#__PURE__*/createContext(undefined);
}

function makeTreatmentProvider(TreatmentContext, client) {
  return function (_ref) {
    var children = _ref.children;

    var _useState = useState(makeStartedRequest()),
        _useState2 = _slicedToArray(_useState, 2),
        request = _useState2[0],
        setRequest = _useState2[1];

    var _useState3 = useState(undefined),
        _useState4 = _slicedToArray(_useState3, 2),
        treatments = _useState4[0],
        setTreatments = _useState4[1];

    useEffect(function () {
      client.resolve(function (result) {
        setTreatments(result);
        setRequest(makeSucceededRequest());
      });
    }, []);
    var context = useMemo(function () {
      return {
        treatments: treatments,
        client: client,
        request: request
      };
    }, [request, treatments]);
    return /*#__PURE__*/_jsx(TreatmentContext.Provider, {
      value: context,
      children: children
    });
  };
}

export function makeUseTreatment(TreatmentContext) {
  return function (treatmentKey) {
    var shouldLogExposure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var context = useContext(TreatmentContext);

    if (!context) {
      throw new Error('Wrap the root of your library or app with a TreatmentProvider');
    }

    var treatments = context.treatments,
        client = context.client,
        request = context.request;
    useEffect(function () {
      if (shouldLogExposure) {
        client.logExposure(treatmentKey);
      }
    }, [client, shouldLogExposure, treatmentKey]);
    var parameters = treatments && treatments[treatmentKey] && treatments[treatmentKey].parameters;
    return {
      request: request,
      parameters: parameters
    };
  };
}
export function makeLaboratoryHooks(client) {
  var TreatmentContext = createTreatmentContext();
  var TreatmentProvider = makeTreatmentProvider(TreatmentContext, client);
  var useTreatment = makeUseTreatment(TreatmentContext);
  return {
    TreatmentContext: TreatmentContext,
    TreatmentProvider: TreatmentProvider,
    useTreatment: useTreatment
  };
}